import { render } from "./TransferWizardContainer.vue?vue&type=template&id=f207c8f6"
import script from "./TransferWizardContainer.vue?vue&type=script&lang=js"
export * from "./TransferWizardContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__